import React, { useState, useEffect, useRef } from 'react';
import './ComboInput.css';

function ComboInput({ value = '', onChange, suggestions = [], placeholder = '', disabled }) {
  const [open, setOpen]       = useState(false);
  const [hi, setHi]           = useState(-1);
  const [showAll, setShowAll] = useState(false);
  const inputRef  = useRef(null);
  const [dropStyle, setDropStyle] = useState({});

  const filtered = showAll
    ? suggestions.filter(Boolean)
    : suggestions.filter(s => s && s.toLowerCase().includes((value || '').toLowerCase()));

  const openDrop = (all = false) => {
    if (disabled) return;
    setShowAll(all);
    const rect = inputRef.current.getBoundingClientRect();
    setDropStyle({ position: 'fixed', top: rect.bottom + 2, left: rect.left,
                   minWidth: Math.max(rect.width, 120), zIndex: 9999 });
    setOpen(true);
    setHi(-1);
  };

  useEffect(() => {
    if (!open) { setHi(-1); return; }
    const clickClose = (e) => {
      if (!inputRef.current?.closest('.ci')?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', clickClose);
    return () => document.removeEventListener('mousedown', clickClose);
  }, [open]);

  const commit = (val) => { onChange(val); setOpen(false); setShowAll(false); };

  const handleKey = (e) => {
    // Left/Right: close dropdown (if open) and bubble to the row navigator
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      if (open) setOpen(false);
      return;
    }
    if (!open) {
      if (e.key === 'Escape') { e.stopPropagation(); return; } // don't bubble to rowNav
      if (e.altKey && e.key === 'ArrowDown') { e.preventDefault(); openDrop(true); }
      // plain Up/Down bubble to rowNav for row navigation
      return;
    }
    // Dropdown open — consume navigation keys here
    e.stopPropagation();
    if (e.key === 'Escape') { e.preventDefault(); setOpen(false); setShowAll(false); return; }
    if (e.key === 'Tab')    { setOpen(false); setShowAll(false); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); setHi(h => Math.min(h + 1, filtered.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setHi(h => Math.max(h - 1, -1)); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      if (hi >= 0 && filtered[hi]) commit(filtered[hi]);
      else setOpen(false);
    }
  };

  return (
    <div className="ci">
      <input
        ref={inputRef}
        value={value || ''}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        onFocus={e => { e.target.select(); }}
        onChange={e => { setShowAll(false); onChange(e.target.value); if (!open) openDrop(false); }}
        onKeyDown={handleKey}
      />
      {open && filtered.length > 0 && (
        <div className="ci-drop" style={dropStyle}>
          {filtered.map((s, i) => (
            <div key={s}
              className={`ci-opt${i === hi ? ' ci-hi' : ''}${s === value ? ' ci-sel' : ''}`}
              onMouseEnter={() => setHi(i)}
              onMouseDown={e => { e.preventDefault(); commit(s); }}>
              {s}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ComboInput;
